import {
  ClaimDefinition,
  StepDefinitionTypes,
  PharmaCompany,
  DosingFrequencyUnit,
  ClaimClearance,
} from 'claimbuilder'

import infoDoc from './assets/ExempliGratia.pdf'
import logo from './assets/ExempliGratia.png'

export const ExempliGratiaClaimDefinition: ClaimDefinition = {
  product: {
    name: 'ExempliGratia',
    informationDocument: infoDoc,
    logo,
    substances: ['Placebo'],
  },
  clearance: ClaimClearance.DEMO,
  owner: PharmaCompany.DEMO,
  steps: [
    {
      type: StepDefinitionTypes.DOCTOR,
    },
    {
      type: StepDefinitionTypes.PATIENT,
      diagnoseOptions: [
        {
          label: 'Diagnose 1',
          value:
            'Diagnose 1: Lorem ipsum dolor sit amet, consetetur sadipscing elitr',
        },
        {
          label: 'Diagnose 2',
          value:
            'Diagnose 2: Sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat',
        },
        {
          label: 'Diagnose 3',
          value:
            'Diagnose 3: At vero eos et accusam et justo duo dolores et ea rebum',
        },
        {
          label: 'Diagnose 4',
          value:
            'Diagnose 4: Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
        },
      ],
    },
    {
      type: StepDefinitionTypes.DOSING,
      unit: 'mg',
      frequencyUnit: DosingFrequencyUnit.DAY,
      frequencies: [
        {
          label: '1',
          value: 1,
        },
        {
          label: '2',
          value: 2,
        },
        {
          label: '3',
          value: 3,
        },
        {
          label: '4',
          value: 4,
        },
        {
          label: '5',
          value: 5,
        },
        {
          label: '6',
          value: 6,
        },
        {
          label: '7',
          value: 7,
        },
        {
          label: '8',
          value: 8,
        },
        {
          label: '9',
          value: 9,
        },
      ],
      dosings: [
        {
          value: 125,
        },
        {
          value: 250,
        },
        {
          value: 500,
        },
      ],
    },
    {
      type: StepDefinitionTypes.ARGUMENTS,
      arguments: [
        {
          label: 'Lorem ipsum',
          description: '',
        },
        {
          label: 'Dolor sit amet',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat',
        },
        {
          label: 'Sed diam voluptua',
          description:
            'At vero eos et accusam et justo duo dolores et ea rebum',
        },
        {
          label: 'Stet clita kasd gubergren',
          description: 'No sea takimata sanctus est Lorem ipsum dolor sit amet',
        },
        {
          label: 'Lorem ipsum dolor sit amet',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua',
        },
        {
          label: 'Ut wisi enim ad minim veniam, quis nostrud exerci',
          description:
            'Tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi',
        },
        {
          label: 'Lorem ipsum dolor sit',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua',
        },
        {
          label: 'At vero eos et accusam et justo duo dolores et ea rebum',
          description:
            'Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet',
        },
        {
          label: 'Nam liber tempor cum soluta nobis',
          description: '',
        },
      ],
    },
    {
      type: StepDefinitionTypes.DISPATCH,
    },
    {
      type: StepDefinitionTypes.SUMMARY,
    },
  ],
}

export default ExempliGratiaClaimDefinition
